import ReminderOptionType from '../helpers/ReminderOptionType';
import createReminderDisplayString from './createReminderDisplayString';

/**
 * Generates localized text for reminder dropdown options given a key
 */

export default function updateReminderStrings(
    reminderDropdownOptions: ReminderOptionType[],
    formatReminderForAllDay: boolean,
    lowercaseFormatter: (value: number) => string
) {
    reminderDropdownOptions.forEach(option => {
        option.text = createReminderDisplayString(
            option.key,
            formatReminderForAllDay,
            lowercaseFormatter
        );
    });
}
